import type { BetaSearch } from '../repositories/betaSearchRepository';

/**
 * Every feed a reader can switch to: their own searches (in Home or not),
 * then each TLDR newsletter they have not subscribed to, marked not in Home.
 * The Feeds page and the header's feed switcher list the same set.
 */
export function readerFeedList(searches: BetaSearch[], publicSearches: BetaSearch[]): BetaSearch[] {
  const owned = new Set(searches.map(feed => feed.id));
  return [...searches, ...publicSearches.filter(feed => !owned.has(feed.id)).map(feed => ({ ...feed, included: false }))];
}

const collator = new Intl.Collator(undefined, { sensitivity: 'base', numeric: true });

/**
 * The switcher's rows: alphabetical by name, narrowed to feeds whose name
 * contains every whitespace-separated word of the query (case-insensitive).
 */
export function filterFeedsForSwitcher(feeds: BetaSearch[], query: string): BetaSearch[] {
  const words = query.toLowerCase().split(/\s+/).filter(Boolean);
  return feeds
    .filter(feed => { const name = feed.name.toLowerCase(); return words.every(word => name.includes(word)); })
    .sort((a, b) => collator.compare(a.name, b.name));
}

/** Whether `feedId` (from a /feeds/:feedId URL) names this feed. */
export function isCurrentFeed(feed: BetaSearch, feedId: string | null): boolean {
  return feedId !== null && (feed.id === feedId || feed.slug === feedId || Boolean(feed.legacy_ids?.includes(feedId)));
}

/** The feed id in a /feeds/:feedId pathname, or null on any other page. */
export function feedIdFromPath(pathname: string): string | null {
  const match = /^\/feeds\/(?:v2\/)?([^/]+)\/?$/.exec(pathname);
  return match ? decodeURIComponent(match[1]) : null;
}
